module.exports = __webpack_public_path__ + "img/ethan_quarantine.fc2ba639.png";